/**
 * Parseo del campo "Categorías (separadas por coma)" del editor de Lo último.
 * "Consejos, Casos de éxito," → ['Consejos', 'Casos de éxito'].
 *
 * Vive aparte del componente: el input se controla con el TEXTO CRUDO y este
 * parseo solo alimenta el payload — parsear el propio value del input se
 * comía la coma final recién tecleada (filter(Boolean) + re-render).
 */
export function parseCategories(raw: string): string[] {
  return raw
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean)
}
